export const fr = {
  networkPage: {
    meta: { title: 'Notre réseau' },
    hero: {
      eyebrow: '1 400+ organismes',
      heading_main: 'Un tout nouveau bassin de',
      heading_em: 'mains disponibles',
      lead: "Rejoignez Purposely et accédez à des dizaines de milliers de bénévoles corporatifs au sein de nos entreprises partenaires. Publiez les quarts dont vous avez besoin, les projets que vous reportez, et laissez notre IA jumeler les bonnes personnes au bon travail.",
      cta: 'Réserver une rencontre pour en savoir plus →',
    },
    stats: [
      { n: '42 000+', label: "Bénévoles corporatifs dans le bassin actif" },
      { n: '180+',    label: "Entreprises partenaires, de 50 à 500 000 employés" },
      { n: '88 %',    label: "Taux de retour des bénévoles dans le réseau" },
      { n: '0 $',     label: "Coût pour les organismes vérifiés — toujours" },
    ],
    features: {
      eyebrow: 'Ce que vous obtenez',
      heading_main: 'Tout ce dont un organisme a besoin pour',
      heading_em: 'transformer des bonnes volontés en impact',
      lead: "Gratuit pour les organismes vérifiés. Votre propre portail, un flux constant de bénévoles corporatifs et une IA qui les jumelle à votre travail.",
      network: {
        tag: 'Accédez au réseau',
        heading_main: "Des dizaines de milliers d'employés,",
        heading_em: 'jumelés à votre cause',
        body: "Quand vous publiez un quart, notre IA le propose discrètement aux entreprises partenaires dont les équipes sont les plus susceptibles de se présenter — selon la localisation, les causes et les compétences. Pas besoin de recruter ; les bonnes personnes vous trouvent.",
        bullets: [
          "Promu auprès de 180+ entreprises partenaires, grandes et petites",
          "Correspondance locale — bénévoles filtrés par ville et temps de trajet",
          "Acheminement par compétences pour le travail pro bono et spécialisé",
          "Réservations de groupe — toute une équipe peut s'inscrire en un clic",
        ],
      },
      projects: {
        tag: 'Petits et grands projets',
        heading_main: "Pas seulement le quart habituel —",
        heading_em: "aussi les projets en attente depuis trop longtemps",
        body: "Un emballage de repas le vendredi, c'est bien. Une équipe qualifiée qui refait votre base de données de donateurs, rafraîchit votre site ou peint l'arrière-salle, c'est encore mieux. Publiez les deux — Purposely jumèle les bénévoles au travail, quelle qu'en soit la forme.",
        bullets: [
          "Quarts récurrents — repas, accueil, tri",
          "Événements ponctuels — galas, courses, collectes, journées communautaires",
          "Pro bono qualifié — design, développement, finances, droit, rédaction",
          '"Projets en attente" — ceux que vous n\'avez jamais eu de mains pour faire',
        ],
      },
      kits: {
        tag: 'Partenaire officiel Purposely',
        heading_main: 'De la trousse à la cause',
        heading_em: 'Concret et à fort impact',
        body: "Kits for a Cause est l'un de nos partenaires vedettes, proposant des expériences d'assemblage de trousses — trousses d'hygiène, trousses scolaires, trousses pour nouveaux arrivants, trousses de réconfort — jumelées à un organisme qui vous tient à cœur. Leur pouvoir d'achat en gros fait en sorte que chaque dollar va plus loin que si vous sourciez vous-même.",
        bullets: [
          "Trousses personnalisées déterminées selon les besoins actuels des organismes",
          "Approvisionnement et logistique pris en charge — matériel livré sur place",
          "Sessions d'assemblage de 1 à 2 heures, 20 à 8 000 bénévoles",
          "Un intervenant de l'organisme pour une expérience interactive",
          "Connecté à des organismes et OBNL de tous types partout au Canada et aux États-Unis",
        ],
        quote: '"Travailler avec Kits for a Cause a été un processus tellement simple et fluide ! Ils sont incroyablement serviables et si organisés ! Notre événement d\'assemblage de trousses s\'est déroulé sans accroc."',
        quoteBy: "— Te-Anna VanDyke, Meridian Credit Union",
        metaSession: 'Session',
        metaSessionVal: '1–2 h',
        metaTeam: "Taille de l'équipe",
        metaTeamVal: '20–8 000',
        metaKits: 'Trousses / session',
        metaKitsVal: '500–5 000',
      },
    },
    logos: {
      label: "Quelques-uns des 1 400+ organismes dans notre réseau",
      items: ['Vancouver Food Bank', 'Union Gospel Mission', 'YWCA Metro', 'BGC Canada', 'Covenant House', 'Stanley Park Ecology', 'DLS Reading'],
    },
    faq: {
      eyebrow: 'Rejoindre le réseau',
      heading: 'Questions, réponses.',
      items: [
        {
          q: "Purposely est-il gratuit pour les organismes?",
          a: "Oui — entièrement gratuit pour les organismes de bienfaisance enregistrés vérifiés (501(c)(3), organismes canadiens enregistrés et équivalents internationaux). Les partenaires corporatifs paient les frais de plateforme.",
        },
        {
          q: "Comment vérifiez-vous les organismes?",
          a: "Nous vérifions les registres de l'IRS, de l'ARC et équivalents; confirmons un contact actif au sein de l'organisme; et effectuons un bref examen des programmes. La plupart des demandes sont approuvées dans les 3 à 5 jours ouvrables.",
        },
        {
          q: "Devons-nous accepter tous ceux qui s'inscrivent?",
          a: "Non. Vous fixez le nombre maximal de participants pour chaque quart et vous pouvez exiger des formulaires de décharge, des minimums d'âge ou une formation avant approbation. Votre portail est la source de vérité — Purposely n'y achemine que des bénévoles qualifiés.",
        },
        {
          q: "Pouvons-nous publier du travail spécialisé ou pro bono?",
          a: "Absolument — et nous vous y encourageons. Identifiez les compétences requises (design, développement, finances, droit, rédaction, opérations) et nous acheminerons la publication vers les bénévoles dont le rôle en entreprise correspond.",
        },
        {
          q: "Comment fonctionne Kits for a Cause?",
          a: "Nous vous rencontrons pour co-concevoir une trousse adaptée à votre communauté. Nous approvisionnons le matériel et le livrons au lieu d'assemblage. Les équipes corporatives assemblent les trousses lors d'un événement de 2 à 4 heures, puis les trousses sont remises directement dans vos circuits de distribution.",
        },
      ],
    },
    cta: {
      heading_main: "Obtenez l'aide que vous attendiez",
      heading_em: 'depuis longtemps',
      sub: "Postulez pour rejoindre le réseau — gratuit pour les organismes vérifiés, approuvé en moins d'une semaine.",
      micro: 'Aucune carte de crédit. Aucuns frais de plateforme. Jamais.',
      button: 'Postuler pour rejoindre →',
    },
  },
}
